/**
 * Created by Mark on 17/04/2017.
 */


/**
 * Created by Mark on 17/04/2017.
 */



import BaseStore from './base-store.js';
import CurriculumConstants from '../constants/curriculum.js';
import Environment from '../constants/environment.js';
import Curriculum from '../classes/curriculum.js';
class CurriculumStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.curriculum = null;
        this.userCurriculums = null;
    }

    _registerToActions(action) {

        switch(action.actionType){
            case CurriculumConstants.UPDATE_ALL_CURRICULUMS:

                this.userCurriculums = action.response.map(function(curriculum){
                    return new Curriculum(curriculum.uid , curriculum.translationID);
                });
                break;
            default: break;
        }

        this.emitChange();
    }

}

export default new CurriculumStore();


// WEBPACK FOOTER //
// ./src/store/curriculum-store.js